/* Once Upon Magic — NEO 2026 — local recently viewed memory */
(() => {
  const uiLocale = (document.documentElement.lang || 'fr').toLowerCase().replace(/_/g, '-');
  const uiLanguage = uiLocale.startsWith('zh') ? (/^zh-(hant|tw|hk|mo)(-|$)/.test(uiLocale) ? 'zh-TW' : 'zh-CN') : uiLocale.split('-')[0];
  const uiCopies = {
  "fr": {
    "review": "Revoir",
    "eyebrow": "Mémoire magique",
    "title": "Vous les aviez remarqués.",
    "intro": "Retrouvez instantanément les pièces consultées récemment sur cet appareil.",
    "clear": "Effacer l’historique",
    "track": "Produits consultés récemment"
  },
  "en": {
    "review": "View again",
    "eyebrow": "Magical memories",
    "title": "They caught your eye.",
    "intro": "Instantly find the pieces you recently viewed on this device.",
    "clear": "Clear history",
    "track": "Recently viewed products"
  },
  "de": {
    "review": "Erneut ansehen",
    "eyebrow": "Magische Erinnerungen",
    "title": "Sie sind Ihnen aufgefallen.",
    "intro": "Finden Sie sofort die Stücke wieder, die Sie kürzlich auf diesem Gerät angesehen haben.",
    "clear": "Verlauf löschen",
    "track": "Kürzlich angesehene Produkte"
  },
  "es": {
    "review": "Volver a ver",
    "eyebrow": "Memoria mágica",
    "title": "Te habían llamado la atención.",
    "intro": "Encuentra al instante las piezas que has visto recientemente en este dispositivo.",
    "clear": "Borrar el historial",
    "track": "Productos vistos recientemente"
  },
  "it": {
    "review": "Rivedi",
    "eyebrow": "Ricordi magici",
    "title": "Avevano attirato la tua attenzione.",
    "intro": "Ritrova subito gli articoli visualizzati di recente su questo dispositivo.",
    "clear": "Cancella la cronologia",
    "track": "Prodotti visualizzati di recente"
  },
  "nl": {
    "review": "Opnieuw bekijken",
    "eyebrow": "Magische herinneringen",
    "title": "Ze vielen je op.",
    "intro": "Vind meteen de artikelen terug die je onlangs op dit apparaat hebt bekeken.",
    "clear": "Geschiedenis wissen",
    "track": "Onlangs bekeken producten"
  },
  "ja": {
    "review": "もう一度見る",
    "eyebrow": "魔法の思い出",
    "title": "気になっていたアイテム。",
    "intro": "この端末で最近チェックしたアイテムをすぐに見つけられます。",
    "clear": "履歴を消去",
    "track": "最近見た商品"
  },
  "zh-CN": {
    "review": "再次查看",
    "eyebrow": "魔法记忆",
    "title": "那些让你心动的好物。",
    "intro": "立即找回你最近在此设备上浏览过的商品。",
    "clear": "清除历史记录",
    "track": "最近浏览的商品"
  },
  "zh-TW": {
    "review": "再次查看",
    "eyebrow": "魔法記憶",
    "title": "那些讓你心動的好物。",
    "intro": "立即找回你最近在此裝置上瀏覽過的商品。",
    "clear": "清除歷史紀錄",
    "track": "最近瀏覽的商品"
  }
};
  const uiCopy = uiCopies[uiLanguage] || uiCopies.fr;

  const STORAGE_KEY = 'oum:recent-products:v1';
  const MAX_ITEMS = 8;
  const preferencesAllowed = () => window.OUMPrivacy?.resolved === true && window.OUMPrivacy.preferencesAllowed === true;
  const clearMemory = () => { try { localStorage.removeItem(STORAGE_KEY); } catch (_) {} };

  const templateName = () => {
    const main = document.querySelector('main[data-template]');
    return (main?.dataset.template || '').split('.')[0];
  };

  const readMemory = () => {
    if (!preferencesAllowed()) return [];
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item?.url && item?.title) : [];
    } catch (_) {
      return [];
    }
  };

  const writeMemory = (items) => {
    if (!preferencesAllowed()) return;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS))); } catch (_) {}
  };

  const formatPrice = (amount, currency) => {
    const numeric = Number(amount);
    if (!Number.isFinite(numeric) || !currency) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency,
        maximumFractionDigits: 2
      }).format(numeric);
    } catch (_) {
      return `${amount} ${currency}`;
    }
  };

  const rememberProduct = () => {
    if (!preferencesAllowed() || templateName() !== 'product') return;

    const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.href.split('?')[0];
    const title = document.querySelector('main h1')?.textContent?.trim()
      || document.querySelector('meta[property="og:title"]')?.content?.trim()
      || document.title;
    const image = document.querySelector('meta[property="og:image:secure_url"]')?.content
      || document.querySelector('meta[property="og:image"]')?.content
      || '';
    const amount = document.querySelector('meta[property="product:price:amount"]')?.content || '';
    const currency = document.querySelector('meta[property="product:price:currency"]')?.content || '';
    const fallbackPrice = document.querySelector('.price')?.textContent?.replace(/\s+/g, ' ')?.trim() || '';
    const price = formatPrice(amount, currency) || fallbackPrice.slice(0, 80);

    if (!canonical || !title) return;

    const item = {
      url: canonical,
      title: title.slice(0, 180),
      image,
      price,
      seenAt: Date.now()
    };
    const next = [item, ...readMemory().filter((entry) => entry.url !== canonical)];
    writeMemory(next);
  };

  const createCard = (item) => {
    const card = document.createElement('a');
    card.className = 'oum-memory-card';
    card.href = item.url;
    card.setAttribute('role', 'listitem');

    const media = document.createElement('span');
    media.className = 'oum-memory-card__media';
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = item.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      media.appendChild(image);
    } else {
      media.classList.add('oum-memory-card__media--empty');
      media.setAttribute('aria-hidden', 'true');
    }

    const body = document.createElement('span');
    body.className = 'oum-memory-card__body';
    const micro = document.createElement('small');
    micro.textContent = uiCopy.review;
    const title = document.createElement('strong');
    title.textContent = item.title;
    body.append(micro, title);
    if (item.price) {
      const price = document.createElement('span');
      price.className = 'oum-memory-card__price';
      price.textContent = item.price;
      body.appendChild(price);
    }

    const arrow = document.createElement('span');
    arrow.className = 'oum-memory-card__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '↗';
    card.append(media, body, arrow);
    return card;
  };

  const renderShelf = () => {
    if (!preferencesAllowed() || templateName() !== 'index' || document.querySelector('[data-oum-memory-shelf]')) return;
    const items = readMemory();
    if (!items.length) return;

    const anchor = document.querySelector('#oum-magic-swipe')?.closest('.shopify-section')
      || document.querySelector('#oum-magic-swipe');
    if (!anchor) return;

    const section = document.createElement('section');
    section.className = 'oum-memory-shelf';
    section.dataset.oumMemoryShelf = 'true';
    section.setAttribute('aria-labelledby', 'OumMemoryShelfTitle');
    section.innerHTML = `
      <div class="oum-memory-shelf__inner">
        <header class="oum-memory-shelf__header">
          <div>
            <p class="oum-neo-eyebrow">${uiCopy.eyebrow}</p>
            <h2 id="OumMemoryShelfTitle">${uiCopy.title}</h2>
            <p>${uiCopy.intro}</p>
          </div>
          <button type="button" class="oum-memory-shelf__clear" data-oum-memory-clear>${uiCopy.clear}</button>
        </header>
        <div class="oum-memory-shelf__track" data-oum-memory-track role="list" aria-label="${uiCopy.track}"></div>
      </div>`;

    const track = section.querySelector('[data-oum-memory-track]');
    items.forEach((item) => track?.appendChild(createCard(item)));
    anchor.insertAdjacentElement('afterend', section);

    section.querySelector('[data-oum-memory-clear]')?.addEventListener('click', () => {
      clearMemory();
      section.remove();
    });
  };

  let booted = false;
  let remembered = false;
  const syncPrivacy = () => {
    if (!booted) return;
    if (!preferencesAllowed()) {
      document.querySelector('[data-oum-memory-shelf]')?.remove();
      // Pending consent never reads history. A resolved refusal also removes it.
      if (window.OUMPrivacy?.resolved === true) clearMemory();
      remembered = false;
      return;
    }
    if (!remembered) { rememberProduct(); remembered = true; }
    renderShelf();
  };
  // A microtask also handles a core that publishes its API after emitting readiness.
  window.addEventListener('oum:privacy-change', () => queueMicrotask(syncPrivacy));
  const boot = () => {
    booted = true;
    syncPrivacy();
    window.OUMPrivacy?.ready?.then(syncPrivacy);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
